const GROUPS = [
  { id: 'SystemAdmin', name: 'System Admin' },
  { id: 'TenantAdmin', name: 'Admin' },
];

export default GROUPS;
